import axiosInstance from './axiosConfig';
import { ApiResult } from './generalService';

export type TreatmentDto = {
  treatmentId: string;
  displayName: string;
  activeSubstance: string | null;
  treatmentClass: string;
  aliases: string[];
};

export const fetchTreatments = () =>
  axiosInstance.get<ApiResult<{ treatments: TreatmentDto[] }>>(`/treatments`);
